<template>
  <div class="home">
    <!-- 轮播 -->
    <el-carousel height="400px" indicator-position="outside">
      <el-carousel-item v-for="item in 5" :key="item">
        <img :src="banner" style="width:100%;height: 100%;" />
      </el-carousel-item>
    </el-carousel>
    <!-- 内容 -->
    <div style="margin:0 25%;">
      <img :src="contentImg" style="width:100%;margin-bottom: 20px;" />
    </div>
    <!-- 客户 -->
    <div style="background: rgb(229,236,248);padding:60px 25%;" class="column">
      <div class="column" style="font-weight: bold;margin-bottom: 30px;">
        <p style="margin-bottom: 6px;">我们的客户</p>
        <div style="width:40px;border-bottom: 2px solid #1E88F5;"></div>
      </div>
      <div class="row" style="justify-content: space-around;width:100%;">
        <img :src="client1" class="cilentImg" />
        <img :src="client2" class="cilentImg" />
        <img :src="client1" class="cilentImg" />
        <img :src="client2" class="cilentImg" />
      </div>
      <div class="row" style="justify-content: space-around;width:100%;margin-top: 20px;">
        <img :src="client1" class="cilentImg" />
        <img :src="client2" class="cilentImg" />
        <img :src="client1" class="cilentImg" />
        <img :src="client2" class="cilentImg" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import banner from '../assets/banner.png'
import content from '../assets/content.png'
import client1 from '../assets/client1.png'
import client2 from '../assets/client2.png'

export default {
  name: 'HomeView',
  data(){
    return {
      banner:banner,
      contentImg:content,
      client1:client1,
      client2:client2
    }
  },
  components: {

  }
}
</script>

<style scoped>
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .cilentImg{
    width:140px;
  }
</style>
